import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-notificaciones-index',
  templateUrl: './notificaciones-index.component.html',
  styleUrls: ['./notificaciones-index.component.css']
})
export class NotificacionesIndexComponent implements OnInit {

  ngOnInit(){
    //this.router.navigate(['/abm/notificaciones/Cliente']);
    this.router.navigate(['/abm/notificaciones/Sistema']);
  }
constructor(private router:Router){

}

}
